import service from '@/services/integration/iset/IsetService'
import IntegrationService from '@/services/integration/IntegrationService'

export const isetModule = {
  strict: process.env.NODE_ENV !== 'production',
  namespaced: true,
  state: {
    categoryList: [],
    categoryListIset: [],
    manufacturerList: [],
    integrationData: {},
    synchronizationLog: [],
  },
  mutations: {
    SET_CATEGORY_LIST(state, payload) {
      state.categoryList = payload.data ?? payload
    },
    SET_CATEGORY_LIST_ISET(state, payload) {
      state.categoryListIset = payload
    },
    SET_MANUFACTURER_LIST(state, payload) {
      state.manufacturerList = payload.response ?? payload.data ?? payload
    },
    SET_INTEGRATION_DATA(state, payload) {
      state.integrationData = payload
    },
    SET_SYNCHRONIZATION_LOG(state, payload) {
      state.synchronizationLog = payload
    },
  },
  actions: {
    async getCategories({ commit }, payload) {
      let response = await service.getCategoriesIntegration(payload)
      commit('SET_CATEGORY_LIST', response.data)
    },
    async getCategoriesIset({ commit }, payload) {
      let response = await service.getCategories({ payload })
      commit('SET_CATEGORY_LIST_ISET', response)
    },
    async getManufacturers({ commit }, payload) {
      let response = await service.getManufacturers(payload)
      commit('SET_MANUFACTURER_LIST', response.data)
    },
    async getIntegrationData({ commit }, payload) {
      let response = await IntegrationService.getIntegrationData(payload)
      commit('SET_INTEGRATION_DATA', response)
    },
    async getSynchronizationLog({ commit }, payload) {
      let response = await service.getSynchronizationLog(payload)
      commit('SET_SYNCHRONIZATION_LOG', response.data)
    },
    setEmptySynchronizationLog({ commit }, payload) {
      commit('SET_SYNCHRONIZATION_LOG', payload)
    },

    async deleteCategoriesGestao(context, payload) {
      const { data } = await service.deleteCategoriesGestao(payload)
      return data
    },
  },
  getters: {
    getCategoryComboBox: (state) => {
      let comboBox = state.categoryList.map((category) => {
        return {
          CODIGO: category.ID,
          NOME: category.NOME,
        }
      })
      return comboBox
    },
    getCategoryIntegratedComboBox: (state) => {
      let comboBox = state.categoryList.filter(
        (category) => category.IDINTEGRACAO != null
      )
      comboBox = comboBox.map((category) => {
        return {
          CODIGO: category.ID,
          NOME: category.NOME,
        }
      })
      return comboBox
    },
    getCategoreisIsetComboBox: (state) => {
      let comboBox = state.categoryListIset.map((category) => {
        return {
          CODIGO: category.id,
          NOME: category.name,
        }
      })
      return comboBox
    },
    getCategoriesIset: (state) => {
      return state.categoryListIset
    },
    getManufacturerList: (state) => {
      return state.manufacturerList
    },
    getSynchronizationLog: (state) => {
      return state.synchronizationLog
    },
    getManufacturerComboBox: (state) => {
      let comboBox = state.manufacturerList.map((manufacturer) => {
        return {
          CODIGO: manufacturer.id,
          NOME: manufacturer.name,
        }
      })
      return comboBox
    },
  },
}
